__webpack_require__.p = "/dini-ag-kim/educationalLevel/heads/main/";